import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-state"
}

import { computed, onMounted, ref } from "vue";
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonTitle,
  IonToolbar,
  modalController
} from "@ionic/vue";
import { closeOutline, saveOutline } from 'ionicons/icons';
import { useStore } from "vuex";
import { translate } from '@hotwax/dxp-components';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProductFacilityGroupModal',
  props: ["selectedFacilityGroups", "type"],
  setup(__props) {

const selectedGroups = ref([]) as any;

const props = __props;
const store = useStore();

const facilityGroups = computed(() => store.getters["util/getFacilityGroups"])

onMounted(() => {
  selectedGroups.value = JSON.parse(JSON.stringify(props.selectedFacilityGroups[props.type]))
})

function closeModal() {
  modalController.dismiss({ dismissed: true, selectedGroups: selectedGroups.value });
}

function isAlreadySelected(id: any) {
  return selectedGroups.value.some((group: any) => group.facilityGroupId === id)
}

function updateSelectedGroups(selectedGroup: any) {
  const currentGroup = selectedGroups.value.find((group: any) => group.facilityGroupId === selectedGroup.facilityGroupId)

  if(currentGroup?.facilityGroupId) {
    selectedGroups.value = selectedGroups.value.filter((group: any) => group.facilityGroupId !== selectedGroup.facilityGroupId)
  } else {
    selectedGroups.value.push(selectedGroup)
  }
}

function isAlreadyApplied(value: string) {
  const type = props.type === 'included' ? 'excluded' : 'included'
  return props.selectedFacilityGroups[type].some((group: any) => group.facilityGroupId === value)
}

function saveFacilityGroups() {
  modalController.dismiss({ dismissed: true, selectedGroups: selectedGroups.value })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.type === "included" ? _unref(translate)("Include facility groups") : _unref(translate)("Exclude facility groups")), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  fill: "clear",
                  color: "danger",
                  disabled: !selectedGroups.value.length,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedGroups.value = []))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Clear All")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        (facilityGroups.value.length)
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityGroups.value, (group) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    key: group.facilityGroupId,
                    onClick: ($event: any) => (!isAlreadyApplied(group.facilityGroupId) ? updateSelectedGroups(group) : null)
                  }, {
                    default: _withCtx(() => [
                      (isAlreadyApplied(group.facilityGroupId))
                        ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.facilityGroupName), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (!isAlreadyApplied(group.facilityGroupId))
                        ? (_openBlock(), _createBlock(_unref(IonCheckbox), {
                            key: 1,
                            checked: isAlreadySelected(group.facilityGroupId)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId), 1)
                            ]),
                            _: 2
                          }, 1032, ["checked"]))
                        : (_openBlock(), _createBlock(_unref(IonNote), {
                            key: 2,
                            slot: "end",
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.type === 'included' ? _unref(translate)("excluded") : _unref(translate)("included")), 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)("No record found")), 1)
            ])),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (saveFacilityGroups()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})